export function activityIdentityCookie(
  token: unknown,
  protocol: string
): string | undefined {
  if (protocol !== "https:") return undefined;

  const attributes = "Path=/; Secure; SameSite=Strict";
  if (
    typeof token !== "string" ||
    token.length === 0 ||
    !/^[A-Za-z0-9._~-]+$/.test(token)
  ) {
    return `KEYCLOAK_TOKEN=; ${attributes}; Max-Age=0`;
  }

  // MLD verifies this bearer token with Keycloak before recording a user identity.
  const cookie = `KEYCLOAK_TOKEN=${token}; ${attributes}`;
  // Count the entire ASCII cookie to stay within browser cookie size limits.
  return cookie.length <= 4096
    ? cookie
    : `KEYCLOAK_TOKEN=; ${attributes}; Max-Age=0`;
}

export function updateActivityIdentityCookie(token?: unknown): void {
  const cookie = activityIdentityCookie(token, window.location.protocol);
  if (cookie !== undefined) {
    const clearCookie = activityIdentityCookie(
      undefined,
      window.location.protocol
    )!;
    document.cookie = clearCookie;
    if (cookie !== clearCookie) document.cookie = cookie;
  }
}

export const activityIdentityCallbacks = {
  onEvent(event: unknown): void {
    if (
      event === "onAuthLogout" ||
      event === "onAuthError" ||
      event === "onAuthRefreshError" ||
      event === "onInitError"
    ) {
      updateActivityIdentityCookie();
    }
  },
  onTokens(tokens: { token?: string }): void {
    updateActivityIdentityCookie(tokens.token);
  },
};
